import React from "react";
import styles from "./JurisdictionFlag.module.scss";

// Real:    56 x 40
// smaller: 21 x 15
// small:   35 x 25
// big:     42 x 30

const SIZES = {
  SMALLER: "15px",
  SMALL: "25px",
  BIG: "30px",
}

const JurisdictionFlag = ({jurisdictionId, size = SIZES.SMALL}) => {
  if (!jurisdictionId) {
    return null;
  }

  const classes = [styles.module, jurisdictionId];

  return (
    <div className={classes.join(" ")} style={{"--height": size}} />
  );
}

JurisdictionFlag.SIZES = SIZES;

export default JurisdictionFlag;